<template>
<div>
    <b-container fluid class="pt-5">
        <b-row no-gutters class="d-flex align-items-stretch">
            <b-col>
                <h1 class="pb-4 fw-600"> 
                    {{ showTranslation(question_name, question_name_e, question_name_c) }}
                </h1>
                <!--<div class="pb-5 mb-4">
                    <b-textarea v-model="overall_comment.overall_comment" type='textarea' rows="6" 
                    :placeholder="`'${question_name}' 문항에 대한 종합 의견을 작성해주세요`">
                    </b-textarea>
                    <div :class="validation_style" class="mt-2 float-left"><fa v-if="validation_icon!=''" :icon="validation_icon"></fa> {{ validation_comment }} </div>
                    <div v-if="overall_comment.id" class="text-right f-90 gray-600 mt-2">Auditor : {{overall_comment.author_name}}, {{overall_comment.time_stamp.slice(0,10)}}</div>
                </div>-->

                <div v-if="subs_loaded && subs.length > 0">
                    <div v-for="(item, index) in subs" :key="item.index" class="mb-45 d-flex justify-content-between">
                        <!-- 기업 답변 영역 -->
                        <div class="border-0 mb-3 w-50 bgray-100 p-3">
                            <sub-component 
                                :sub_type="item.sub_type"
                                :item="item"
                                :is_disabled_by_parent="true"
                                :audit_mode="true"
                                :print_mode="true"
                                :is_final_sub_component="index == subs.length - 1"
                                @update-pipeline="handleUpdatePipeline"
                                @sub-load-finished="handleSubLoadFinished"
                                @update-sub-for-print="handleUpdateSubForPrint"
                                >
                                <!-- @load-finished="handleLoadFinished" -->
                            </sub-component>
                        </div>
                        
                        <!-- Auditor 평가영역 -->
                        <div class="border-0 bm-3 w-50 p-3">
                            <evaluation-component 
                                :sub_code="item.sub_code"
                                :ev_item="qe_evaluate_result[item.sub_code]"
                                :sub_description="item.sub_description"
                                :print_mode="true"
                                @evaluation-load-finished="handleEvaluationLoadFinished"
                                >
                            </evaluation-component>
                        </div>                                   

                        <hr class="border-0 pb-5">  
                    </div>
                </div>
            </b-col>        
        </b-row>   
        <hr class="border-0 mb-5 py-5">
    </b-container>
</div>
</template>

<script>
import { mapState } from 'vuex';
import * as th from 'tree-helper';
import EvaluationComponent from '@shared_components/admin/components/evaluations/EvaluationComponent';
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';

export default {
    props: {
        question_code: {
            type: String
        },
    },
    components:{
        EvaluationComponent        
    },
    data () {
        return {
            pipeline_key: Math.random()*1000, 

            save_state:'not_saved',

            validation_comment:'',
            validation_icon:'',
            validation_style:'',

            subs: [],
            subs_loaded: false,

            question_name: '',
            question_name_e: '',
            question_name_c: '',
            comment: '',
            question_info_box: '',
            is_writable: '',
            is_visible: '',
            question_contents: [],
            load_complete_sub: [],
            load_complete_evaluation: [],

            is_loaded_subs: false,
            is_loaded_evs: false,
            is_loaded: false
        };
    },
    computed: {
        ...mapState(['template_tree']),
        ...mapState('questions',['answer_company']),
        ...mapState('score', ['is_evaluate_loaded', 'evaluate_results']),
        ...mapState('industry_scores', ['qe_evaluate_result']),
        target_campaign_id () {
            if (this.$route.query.cmp || this.$route.query.campaign_id) {
                return this.$route.query.cmp || this.$route.query.campaign_id;
            }
            
            return this.view_mode === 'provider'
                ? this.answer_company.campaign_id
                : this.campaign_in_progress.campaign_id;
        },
        target_company_id () {
            if (this.$route.query.cpn || this.$route.query.company_id) {
                return this.$route.query.cpn || this.$route.query.company_id;
            }

            return this.view_mode === 'provider'
                ? this.answer_company.company_id
                : this.company_id;
        },
        target_template_contents(){
            return this.template_tree.template_contents;
        }
    },
    watch: {
        save_state(newValue) {
            if (newValue == 'saving') {
                this.validation_comment = '저장 중 입니다.';
                this.validation_icon = 'hourglass';
                this.validation_style = 'ih-validation-saving';
            }
            else if (newValue == 'saved') {
                this.validation_comment = '저장 되어있습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-saved';
            }
            else if (newValue == 'resaved') {
                this.validation_comment = '변경 저장 되었습니다';
                this.validation_icon = 'check';
                this.validation_style = 'ih-validation-resaved';
            }
        },
        is_loaded_subs (_is_loaded) {
            if (_is_loaded && this.is_loaded_evs && !this.is_loaded) {
                this.handleLoadFinished();
            }
        },
        is_loaded_evs (_is_loaded) {
            if (_is_loaded && this.is_loaded_subs && !this.is_loaded) {
                this.handleLoadFinished();
            }
        }
    },
    async created () {
        await Promise.all([
            this.initializeQuestion(this.question_code)
        ]);
    },
    beforeDestroy () {
        this.pipeline_key = Math.random() * 1000;
        this.save_state ='not_saved';
        this.validation_comment ='';
        this.validation_icon ='';
        this.validation_style ='';
        this.subs = [];
        this.subs_loaded = false;
        this.question_name = '';
        this.question_name_e = '';
        this.question_name_c = '';
        this.comment = '';
        this.question_info_box = '';
        this.is_writable = '';
        this.is_visible = '';
        this.question_contents = [];
        this.load_complete_sub = [];
        this.load_complete_evaluation = [];
        this.is_loaded_subs = false;
        this.is_loaded_evs = false;
        this.is_loaded = false;
    },
    methods: {
        async initializeQuestion (question_code) {
            th.breadthFirstSearch(this.target_template_contents, async (node) => {
                if(node.question_code == question_code){
                    this.comment = node.comment;
                    this.question_name = node.question_name;
                    this.question_infobox = node.question_infobox;
                    this.is_writable = node.is_writable;
                    this.is_visible = node.is_visible;
                    this.question_contents = typeof(node.question_contents) == 'string'
                        ? JSON.parse(node.question_contents)
                        : node.question_contents;
                    this.is_completed = node.is_completed;
                }
            });

            if (this.question_contents.length === 0) {
                this.handleLoadFinished();
            } else {
                await this.readSubs(this.question_contents);
            }
        },
        async readSubs (question_contents) {
            this.subs = [];
            this.subs_loaded = false;

            let _subs = [];
            const _question_contents = Array.isArray(question_contents) ? question_contents.join(',') : question_contents;
            const _res_subs = await this.$axios.get('/subs', {
                params: {
                    campaign_id: this.answer_company.campaign_id || this.$route.query.cmp,
                    company_id: this.answer_company.company_id || this.$route.query.cpn,
                    sub_codes: _question_contents
                }
            });

            if (_res_subs.data && _res_subs.data.length) {
                _res_subs.data.forEach(_sub => {
                    _subs.push(generateSubcomponentDataBy(_sub, this.question_code));
                });
            }
            this.subs = _subs;
            this.$nextTick(() => {
                this.subs_loaded = true;
            });
        },
        handleUpdateSubForPrint (updated_sub) {
            const idx = this.subs.findIndex(item => item.sub_code === updated_sub.sub_code);
            if (idx > -1) {
                this.$set(this.subs, idx, generateSubcomponentDataBy({ ...this.subs[idx], ...updated_sub }));
            }
        },
        handleSubLoadFinished (loaded_sub_code) {
            this.load_complete_sub.push(loaded_sub_code);
            if (this.load_complete_sub.length === this.subs.length) {
                this.is_loaded_subs = true;
            }
        },
        handleEvaluationLoadFinished (loaded_sub_code) {
            this.load_complete_evaluation.push(loaded_sub_code);
            if (this.load_complete_evaluation.length === this.subs.length) {
                this.is_loaded_evs = true;
            }
        },
        handleLoadFinished(){
            this.$emit('load-finished', this.question_code);
            this.is_loaded = true;
        },
        handleUpdatePipeline(){
            this.pipeline_key += 1;
        }
    }
};
</script>
